<template>
  <v-carousel 
    v-if="showHeaderSlider && system" 
    cycle 
    hide-delimiter-background 
    show-arrows-on-hover
    class="rounded-0"
  >
    <template v-slot:prev="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on"><v-icon>mdi-chevron-left</v-icon></v-btn>
    </template>
    <template v-slot:next="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on"><v-icon>mdi-chevron-right</v-icon></v-btn>
    </template>
    <v-carousel-item 
      v-if="system.sliders.length" 
      v-for="(item, index) in system.sliders" 
      :key="index"
      :src="`${apiBaseUrl}/uploads/${item.path}`"
      lazy-src="@/assets/slides/default.png"
    />
    <v-carousel-item 
      v-if="!system.sliders.length" 
      src="@/assets/slides/default.png"
    />
    <div :class="$style.systemInfo">
      <v-row>
        <v-col 
          cols="12" 
          class="text-center white--text"
          :class="$style.systemName"
        >
          <h3 
            class="mb-2" 
            :class="$vuetify.breakpoint.lgAndUp ? 'display-3' : 'display-2'"
          >
            {{ system.ten }}
          </h3>
          <span class="display-1">
            {{ config.provinceName }}
          </span>
        </v-col>
      </v-row>
    </div>
    <div :class="$style.listModule">
      <v-container fluid>
        <Module />
      </v-container>
    </div>
  </v-carousel>
</template>
<script>
import { mapState } from 'vuex';
import Module from '@/components/public/home/Module';
export default {
  components: {
    Module,
  },
  computed: {
    ...mapState([
      'system', 
      'config', 
      'showHeaderSlider'
    ]),
    apiBaseUrl() {
      return this.config.beUrl;
    }
  }
}
</script>
<style module>
  .systemInfo {
    position: absolute;
    top: 30%;
    left: 0; 
    right: 0;
  }
  .systemName {
    text-transform: uppercase;
    text-shadow: 2px 2px #00796b;
  }
  .listModule {
    position: absolute;
    bottom: 5%;
    left: 0; 
    right: 0;
  }
</style>